import {
  PLACE_ORDER_BILLING_STEP_URL,
  PLACE_ORDER_INFO_URL, PLACE_ORDER_PRICE_REVIEW_STEP_URL,
  PLACE_ORDER_REVIEW_STEP_URL_V2,
  PLACE_ORDER_REVIEW_STEP_URL,
  PLACE_ORDER_SAMPLES_SCIENCE_STEP_URL,
  PLACE_ORDER_SAMPLES_STEP_URL,
  PLACE_ORDER_SLIDES_STEP_URL,
} from 'constants/urls';

const StepsURLMappingV = {
  0: PLACE_ORDER_INFO_URL,
  1: PLACE_ORDER_SAMPLES_STEP_URL,
  2: PLACE_ORDER_SAMPLES_SCIENCE_STEP_URL,
  3: PLACE_ORDER_SLIDES_STEP_URL,
  4: PLACE_ORDER_PRICE_REVIEW_STEP_URL,
  5: PLACE_ORDER_BILLING_STEP_URL,
};

export const getOrderFormSteps = (url) => ({
  ...StepsURLMappingV,
  6: url === PLACE_ORDER_REVIEW_STEP_URL_V2 ? PLACE_ORDER_REVIEW_STEP_URL_V2 : PLACE_ORDER_REVIEW_STEP_URL,
});
